module.exports = __webpack_public_path__ + "static/media/invite.4f484a30.svg";